import { render } from "./MyApps.vue?vue&type=template&id=927604a2&scoped=true"
import script from "./MyApps.vue?vue&type=script&lang=js"
export * from "./MyApps.vue?vue&type=script&lang=js"

import "./MyApps.vue?vue&type=style&index=0&id=927604a2&scoped=true&lang=scss"

import exportComponent from "/opt/jenkins/workspace/asoworld-uatnf9mf/asoworld-wap-frontend/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-927604a2"]])

export default __exports__